import React, { useContext } from 'react';
import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../../../Types/ObjektVy';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import query from './Queries/ReservFor.gql';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import {
  ReservForQuery_db_LRAttestrattReserv_All,
  ReservForQuery,
  ReservForQueryVariables,
} from './Queries/_QueryTypes/ReservForQuery';
import EDListItem from '../../../../../../../BaseComponents/List/Components/EDListItem';
import { makeStyles } from 'tss-react/mui';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';
import EDList from '../../../../../../../BaseComponents/List/EDList';
import { LoginStateContext } from '../../../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import ReservListItem from '../Reserver/Components/ReserverListItem';
import shortid from 'shortid';

interface IProps extends IBusinessCollectionProps {}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row nowrap',
    borderBottom: `1px solid ${theme.palette.divider}`,

    ['&:last-child']: { borderBottom: 'none' },
  },
  item: {
    width: 'calc(100% / 3 - 48px / 3)',
    ['&:last-child']: { flexGrow: 1 },
  },

  containerSmall: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,

    ['&:last-child']: { borderBottom: 'none' },
  },

  itemSmall: {
    width: '100%',
  },

  pointer: { cursor: 'pointer' },
}));

const ReservForComp: IObjektVyComp = {
  caption: '',
  comp: (props: IProps) => <ReserverForView {...props} />,
};

const ReserverForView: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const loginStateContext = useContext(LoginStateContext);
  const isSmallScreen = useIsSmallScreen();
  const { classes } = useStyles();

  const dateString = new Date().toLocaleDateString('sv-SE');
  const reservForQuery = useQuery<ReservForQuery, ReservForQueryVariables>(
    query,
    {
      variables: {
        dbName: activeDatabase ?? '',
        routineID: 17001,
        userSign: loginStateContext.sign ?? '',
        date: dateString,
      },

      skip: !activeDatabase || !loginStateContext.sign,
    }
  );

  if (reservForQuery.loading) {
    return <EDAvenyProgress />;
  }

  return (
    <>
      <EDList
        style={{
          width: '100%',
        }}
      >
        {reservForQuery.data &&
        (reservForQuery.data.db?.LRAttestrattReserv_All?.length ?? 0) > 0 ? (
          reservForQuery.data.db?.LRAttestrattReserv_All?.map(
            (standIn: ReservForQuery_db_LRAttestrattReserv_All, index) => {
              const key = shortid.generate();
              return isSmallScreen ? (
                <ReservListItem
                  isAuto={standIn.AUTOSKAPAD ?? false}
                  isSmallScreen={isSmallScreen}
                  isReservFor
                  key={key}
                  level={standIn.AUTOSKAPAD_LEVEL ?? 0}
                  pointer={classes.pointer}
                  standIn={standIn}
                  index={index}
                />
              ) : (
                <ReservListItem
                  isAuto={standIn.AUTOSKAPAD ?? false}
                  isSmallScreen={isSmallScreen}
                  isReservFor
                  key={key}
                  level={standIn.AUTOSKAPAD_LEVEL ?? 0}
                  pointer={classes.pointer}
                  standIn={standIn}
                  index={index}
                />
              );
            }
          )
        ) : (
          <EDListItem>
            <EDTypography>Det finns ingen frånvaro registrerad</EDTypography>
          </EDListItem>
        )}
      </EDList>
    </>
  );
};

export const ReservFor: IObjektVy = {
  type: 'ObjektVy',
  id: 'ReservFor',
  info: {},
  def: () => ReservForComp,
};
